import { LoanGradeType } from '@apply/constants';
import { InterestAcrualType } from '../../../../../../../../../common/constants/InterestAcrualType';

/** What the Loan section needs to know about the loan being added/edited (it doesn't edit these itself). */
export interface LoanStepContext {
    /** A sub note's interest type (from its master note); 0 shows "Interest Rate", anything else "Sprd over Prime". */
    interestTypeId?: number;
    /** The loan's saved grade; cancelling the Grade Reason prompt puts it back. */
    savedGrade?: LoanGradeType;
}

export const defaultLoanStepContext: LoanStepContext = {
    interestTypeId: undefined,
    savedGrade: undefined,
};

export interface LoanForm {
    promissoryNote: number | undefined;
    /** "Apprvd Loan Amt" */
    commitment: number | undefined;
    /** Bridge loans only; 0 is a valid amount. */
    bridgeFunded: number | undefined;
    interestRate: number | undefined;
    interestAcrualTypeId: InterestAcrualType | undefined;
    interestRateFloor: number | undefined;
    interestRateCeiling: number | undefined;
    reserveRate: number | undefined;
    grade: LoanGradeType | undefined;
    /** Entered when the grade changes on a loan that's past Approved. */
    gradeReason: string;
    /** Sub notes only; undefined is "not answered". */
    entireStructure: boolean | undefined;
    underwritingFee: number | undefined;
    originationFee: number | undefined;
    brokerShare: number | undefined;
    brokerAdditional: number | undefined;
    liquidity: number | undefined;
}

export const emptyLoanForm: LoanForm = {
    promissoryNote: undefined,
    commitment: undefined,
    bridgeFunded: undefined,
    interestRate: undefined,
    interestAcrualTypeId: undefined,
    interestRateFloor: undefined,
    interestRateCeiling: undefined,
    reserveRate: undefined,
    grade: undefined,
    gradeReason: '',
    entireStructure: undefined,
    underwritingFee: undefined,
    originationFee: undefined,
    brokerShare: undefined,
    brokerAdditional: undefined,
    liquidity: undefined,
};
